import React from 'react';

const SigninComplete = ({ handleSigninComplete }) => {
  return (
    <div>
      <button onClick={() => handleSigninComplete()}>
        Click Me to Move on.
      </button>
    </div>
  );
};

export default SigninComplete;
